// Antes: MutationObserver sobre todo el body (costo INP permanente).
// Ahora: listener de focusin, mismo comportamiento (un solo disparo por carga de página).
(function () {
  var done = false;
  document.addEventListener("focusin", function (e) {
    if (done) return;
    var input = e.target;
    if (
      input &&
      input.matches &&
      input.matches("input.boost-sd__search-widget-init-input")
    ) {
      done = true;
      input.click();
      var length = input.value.length;
      input.setSelectionRange(length, length);
    }
  });
})();
